import { styles } from './template.scss';
import { styles as commonStyles } from '../../assets/common.scss';

export const templateImportantMessages = document.createElement('template');

templateImportantMessages.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
    <gz-grid-view hasSelectableRows removeFilters hideFooter hideFiltersToggle disableGridSettings showGlobalActions showToolbarRefresh>
      <div class="controls-header" slot="grid-header-actions-slot">
        <!-- button text is added in view, because it needs to be translated -->
        <gz-button id="addNewButton"  class="primary"></gz-button>
        <gz-button id="enableButton"  class="primary"></gz-button>
        <gz-button id="disableButton" class="primary"></gz-button>
        <gz-button id="deleteButton"  class="primary"></gz-button>
      </div>
    </gz-grid-view>
  </div>
`;
